import type { ISocial } from "../../../../types/models/social.models.types";
import { useDeleteHttp } from "../../http.hook";

interface IResponse {
  social: ISocial;
}

export function useRemoveFixedPayoutAdminHttp() {
  return useDeleteHttp<null,IResponse>({
    path: "/admin/socials/:socialId/fixed-payout",
  });
}
